module.exports = __webpack_public_path__ + "static/media/verify-letter-red.80d902c6.svg";